<template>
  <div class="policy">
    <common-layout>
      <div slot="header">
        <div class="policy_tabs">
          <span
              v-for="btn in tabs"
              :key="btn.id"
              @click="handleClick(btn.id)"
              :class="{ active_t: activeName == btn.id }">
            {{ btn.name }}
          </span>
        </div>
        <ul class="policey_nav">
          <li>内容管理</li>
          <li class="active-Tab">信息维护</li>
        </ul>
      </div>
      <div slot="container">
        <div class="policy-search">
          <el-button
              type="success"
              icon="el-icon-plus"
              @click="add"
              style="background: #623aa2; border: none">
            新增
          </el-button>
          <el-input
              placeholder="请输入内容"
              v-model="queryList.keyword"
              class="input-with-select"
              @keyup.enter.native="search"
              clearable
              @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <div class="selectType" >
            <span>所属年度：</span>
            <el-date-picker
                v-model="queryList.annual"
                :picker-options="pickerOptions"
                type="year"
                placeholder="选择年度"
                format="yyyy"
                value-format="yyyy"
                @change="search(true)"
            ></el-date-picker>
          </div>
        </div>
        <div id="table">
          <!--动态绑定长宽-->
          <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              type="index"
              @selection-change="tabSelect"
              :header-cell-style="headerStyle"
          >
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column :prop="activeName === 3 ? 'ename' : 'title'" :label="activeName === 3 ? '职工姓名' : '标题'" align="center"></el-table-column>
            <el-table-column
                prop="annual"
                label="所属年度"
                align="center"
                width="200">
            </el-table-column>
            <el-table-column :prop="activeName === 2 ? 'amount' : 'content'" :label="contentEnum[activeName-1]" align="center">
              <template slot-scope="scope">
                <div  >
                  <div v-if="activeName === 2" style="text-align: center">{{scope.row.amount}}</div>
                  <div v-if="activeName !== 2">
                    <div class="overflow-hidde" v-html="scope.row.content"></div>
                  </div>
                </div>
<!--                <el-tooltip placement="top">-->
<!--                  <div style="width: 400px;" slot="content" v-html="activeName === 2 ? scope.row.amount : scope.row.content"></div>-->

<!--                </el-tooltip>-->
<!--                <div v-html="activeName === 2 ? 'amount' : 'content'"></div>-->
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- <el-button-group> -->
                <el-button size="mini" @click="handelDialogEdit(scope.row.id)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
                  删除
                </el-button>
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryList.page"
            :page-size="queryList.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
            style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <dialog-year-report v-if="dialogFormVisible" :title="Title" :dialogFormVisible="dialogFormVisible"
                        @search="search" :dialogParams="dialogParams" @handelDialogAdd="handelDialogAdd"
                        @handelDialogClose="handelDialogClose"></dialog-year-report>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from '../../components/tinymce-editor/tinymce-editor';
import CommonLayout from '../../components/common-layout.vue';
import { DisabledDateFn } from '@/utils/tool';
import DialogYearReport from "@/page/content/component/dialogYearReport.vue";
export default {
  name: "infoMaintenance",
  components: {
    DialogYearReport,
    editor,
    CommonLayout
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      //禁用日期选择
      disabledDateFn(time) {
        return DisabledDateFn(time);
      },
      queryList:{
        page:1,
        pageSize:10,
        title: "",
        annual:"",
        keyword: ""
      },
      contentEnum:['报告内容','营业额(元)','维权内容','履责内容'],

      is_submit: true,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      show: false,
      synchronousPublishingList: [
        {
          label: '创业孵化平台',
          value: 1
        },
        {
          label: '金融服务平台',
          value: 2
        }
      ],
      tabs: [
        {
          id: 1,
          name: '年度报告'
        },
        {
          id: 2,
          name: '经营管理'
        },
        {
          id: 3,
          name: '职工权益维护'
        },
        {
          id: 4,
          name: '社会责任履行'
        }
      ],
      urlLise : [
        'information-annual-report',
        'information-operate-manage',
        'information-employee-equity',
        'information-social-liability',
      ],
      type: '',
      activeName: 1,
      selected: '',
      searchValue: '',
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      dialogParams:{
        type:'add',
        id:'',
        selectIndex:this.activeName
      },
      Title: '',
      tableData: [],
      ruleForm: {
        title: "", // 标题
        annual: "", // 所属年度
        content: "", // 维护内容
        attachments: "" // 附件
      },
    };
  },
  created() {
    this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
  },
  methods: {

    pubClear() {
      this.ruleForm.publishing_platform = '';
    },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getDate(url) {
      this.http.post(this.urlConfig.devUrl +url,this.queryList).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
          this.show = !!this.tableData[0].category_second;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    handelDialogAdd(){
      this.search()
    },
    handelDialogEdit(id){
      this.Title = '编辑';
      this.dialogParams = {
        type:'edit',
        id:id,
        selectIndex:this.activeName
      }
      this.dialogFormVisible = true
    },
    handelDialogClose(){
      this.dialogFormVisible = false
      this.search()
    },
    //新增
    add() {
      this.Title = '新增';
      this.dialogFormVisible = true;
      this.dialogParams = {
        type:'add',
        id : '',
        selectIndex:this.activeName
      }
    },
    //编辑
    handleEdit(val) {
      this.Title = '编辑';
      this.dialogFormVisible = true;
      this.http.get('Policy/' + val.id).then(res => {
        if (res.code === 0) {
          this.ruleForm = res.data;

          if (this.ruleForm.publishing_platform !== '') {
            const data = res.data.publishing_platform.split(',');
            this.ruleForm.publishing_platform = data.map(Number);
          } else {
            this.ruleForm.publishing_platform = '';
          }
          console.log('s数据结果', this.ruleForm);
        }
      });
    },
    //提交
    submitForm(formName) {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('publishing_platform', this.ruleForm.publishing_platform);
          let obj = JSON.parse(JSON.stringify(this.ruleForm));

          obj.category_first = this.activeName;
          obj.publishing_platform = this.ruleForm.publishing_platform.toString();
          console.log(obj, 'obj');
          if (this.activeName == 1) {
            delete obj.category_second;
          }
          if (!obj.id) {
            this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/finance/policy/create`, obj)
                .then(res => {
                  if (res.code == 0) {
                    this.ResetSearch(['searchValue', 'type']);
                    this.queryList.page = 1
                    this.$message.success('新建成功');
                    this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
                    this.dialogFormVisible = false;
                    this.$refs[formName].resetFields();
                  } else {
                    this.$message.error(res.status);
                  }
                });
          } else {
            this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/finance/policy/update`, obj)
                .then(res => {
                  if (res.code == 0) {
                    this.ResetSearch(['searchValue', 'type']);

                    this.$message.success('编辑成功');
                    this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
                    this.dialogFormVisible = false;
                    this.$refs[formName].resetFields();
                  } else {
                    this.$message.error(res.status);
                  }
                });
          }
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //搜索
    search() {
      this.queryList.page = 1
      this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
    },
    selectType(e) {
      this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
            this.http.delete(
                `${urlConfig.devUrl}apij2/admin-api/voucher/${this.urlLise[this.activeName-1]}/delete?id=${row.id}`,
                '').then(res => {
              if (res.code === 0) {
                // this.ResetSearch(['searchValue', 'type']);
                this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
                // this.searchValue = '';
                // this.type = '';
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //翻页
    handleCurrentChange(val) {
      this.queryList.page = val
      this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
    },
    //选择行数
    tabSelect(sec) {
      let ids = '';
      for (let i of sec) {
        ids += i.id + ',';
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    // 切换tab
    handleClick(val) {
      console.log(val,'val')
      this.activeName = val;
      this.searchValue = '';
      this.type = '';
      this.getDate('apij2/admin-api/voucher/' + this.urlLise[this.activeName-1]+'/page');
    }
  }
};
</script>

<style lang="scss" scoped>
.policy {
  height: 100%;

  .policy-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  .policy_tabs {
    width: 600px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }

  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: '/';
        }
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
.overflow-hidde{
  max-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box;
  　-webkit-box-orient:vertical; //子元素应该被水平或垂直排列
  　-webkit-line-clamp:1; //3行后显示省略号
}
</style>
